import { FirestoreOrderSummary, OrderSummary } from '@lib/types';

export function fromFirestoreOrderSummaryToOrderSummary(
  firestoreOrder: FirestoreOrderSummary,
): OrderSummary {
  if (!firestoreOrder?.createdAt) {
    // Fallback to avoid crash on new/corrupt documents
    const now = new Date();
    return { ...firestoreOrder, seenAt: now, createdAt: now };
  }
  return {
    ...firestoreOrder,
    seenAt: firestoreOrder.createdAt.toDate(),
    createdAt: firestoreOrder.createdAt.toDate(),
  };
}
